
import { useState, useCallback, useMemo } from 'react';

export const useSubscriptionsFiltering = (
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams) => void
) => {
  // Получаем параметры фильтров из URL
  const [statusFilter, setStatusFilter] = useState<string | null>(
    searchParams.get('status') || ''
  );
  const [courierFilter, setCourierFilter] = useState<string | null>(
    searchParams.get('courier') || ''
  );

  const handleStatusChange = useCallback((status: string) => {
    if (status) {
      setStatusFilter(status);
      const newParams = new URLSearchParams(searchParams);
      newParams.set('status', status);
      setSearchParams(newParams);
    } else {
      setStatusFilter(null);
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('status');
      setSearchParams(newParams);
    }
  }, [searchParams, setSearchParams]);

  const handleCourierChange = useCallback((courierId: string) => {
    if (courierId) {
      setCourierFilter(courierId);
      const newParams = new URLSearchParams(searchParams);
      newParams.set('courier', courierId);
      setSearchParams(newParams);
    } else {
      setCourierFilter(null);
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('courier');
      setSearchParams(newParams);
    }
  }, [searchParams, setSearchParams]);

  const handleClearFilter = useCallback(() => {
    setStatusFilter(null);
    setCourierFilter(null);
    const newParams = new URLSearchParams();
    setSearchParams(newParams);
  }, [setSearchParams]);

  // Синхронизируем фильтры при изменении URL
  useMemo(() => {
    const statusFromUrl = searchParams.get('status');
    const courierFromUrl = searchParams.get('courier');
    
    if (statusFromUrl !== statusFilter) {
      setStatusFilter(statusFromUrl || null);
    }
    
    if (courierFromUrl !== courierFilter) {
      setCourierFilter(courierFromUrl || null);
    }
  }, [searchParams, statusFilter, courierFilter]);

  return {
    statusFilter,
    courierFilter,
    handleStatusChange,
    handleCourierChange,
    handleClearFilter
  };
};
